// Resolves the final list of IDs to submit after a full (unpaginated) fetch.
// When select-all is still active, every fetched ID is included.
// When select-all was followed by unchecking some rows, those rows are dropped:
// `deselectedRowIds` carries the ones a sort pushed out of the loaded window,
// `data` vs `selectedRows` covers the ones still on screen. Virtually-selected
// (never-loaded) rows are kept — the user never saw them to uncheck.
export const buildFinalIds = (
  allIds: string[],
  selectAllChecked: boolean,
  selectedRows: Record<string, unknown>[],
  data: Record<string, unknown>[] | null | undefined,
  idItem: string,
  deselectedRowIds: Set<string>
): string[] => {
  if (selectAllChecked && deselectedRowIds.size === 0) {
    return allIds;
  }

  // IDs visible in the current page that the user has selected
  const selectedIdSet = new Set(
    selectedRows.map((row) => row[idItem]?.toString())
  );
  const excludeSet = new Set<string>();
  deselectedRowIds.forEach((id) => excludeSet.add(id));
  // IDs from the loaded page that the user did NOT select (i.e. unchecked)
  (data ?? []).forEach((row) => {
    const id = row[idItem]?.toString();
    if (id !== undefined && !selectedIdSet.has(id)) excludeSet.add(id);
  });

  return allIds.filter((id) => !excludeSet.has(id));
};
